import memoizeOne from 'memoize-one';
import { MatchingSystemType, } from 'components/automations/components/nodeTypes/types';
import { MatchBoolean, MatchTokenLanguage, MatchTokenQueue, MatchTokenStatus, MatchTokenTags, } from './matchComponents';
export const getMatchComponent = memoizeOne((variable) => {
    if (variable === undefined) {
        return null;
    }
    if (variable.scope === 'system') {
        if (variable.variableType === MatchingSystemType.TAGS) {
            // token field with tags style and tag-search
            return MatchTokenTags;
        }
        if (variable.variableType === MatchingSystemType.QUEUE) {
            // token field with and queue-search
            return MatchTokenQueue;
        }
        if (variable.variableType === MatchingSystemType.STATUS) {
            // select-field, 'open', 'closed', 'pending', 'awaitingpending'
            return MatchTokenStatus;
        }
        if (variable.variableType === MatchingSystemType.LANGUAGE) {
            // token field with language-codes
            return MatchTokenLanguage;
        }
        if (variable.variableType === MatchingSystemType.AGENT_HAS_REPLIED ||
            variable.variableType === MatchingSystemType.USER_HAS_REPLIED ||
            variable.variableType ===
                MatchingSystemType.AGENT_HAS_REPLIED_TRIGGER ||
            variable.variableType === MatchingSystemType.USER_HAS_REPLIED_TRIGGER) {
            return MatchBoolean;
        }
    }
    return null;
});
